// extracted by mini-css-extract-plugin
export var container = "index-module--container--2m0lu";
export var flexParent = "index-module--flexParent--jtEfB";
export var flex = "index-module--flex--P-1Iq";
export var header = "index-module--header--2AOMR";
export var center = "index-module--center--1s6Gy";